import { render, staticRenderFns } from "./CreateWIPackageModal.vue?vue&type=template&id=f117dac8&scoped=true"
import script from "./CreateWIPackageModal.vue?vue&type=script&lang=js"
export * from "./CreateWIPackageModal.vue?vue&type=script&lang=js"
import style0 from "./CreateWIPackageModal.vue?vue&type=style&index=0&id=f117dac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f117dac8",
  null
  
)

export default component.exports